// Shared Digital Exhibit helpers

import { getHighlightMarkup } from "@/core/utils";

// Exhibit text markup. Layers an exhibit-only convention on top of the shared
// **accent** one: text wrapped in `backticks` opts out of the page's uppercase
// style (text-transform) via .dx-verbatim — e.g. an artist who styles their
// name lowercase. The two compose and nest in any order. Kept exhibit-scoped
// (not in the shared getHighlightMarkup) so a stray backtick elsewhere on the
// site stays literal.
export const getExhibitMarkup = (text?: string | null): string =>
  getHighlightMarkup(text || "").replace(/`(.+?)`/g, '<span class="dx-verbatim">$1</span>');

// ACF select values arrive as single-value arrays; accent selections map to
// the page-level CSS custom properties set by DigitalExhibitTheme.
export const accentVar = (accent?: string[] | string | null): string | undefined => {
  const value = Array.isArray(accent) ? accent[0] : accent;
  if (!value) return undefined;
  return `var(--dx-${value.replace("_", "-")})`;
};

// Unwrap a single-value ACF select array
export const selectValue = <T = string>(value?: T[] | T | null): T | undefined => {
  if (Array.isArray(value)) return value[0];
  return value ?? undefined;
};
